<template>
  <div
    class="t-item-container"
  >
    <button
      type="button"
      class="t-info-container"
      @click="goToDetail(technician)"
    >
      <div
        v-if="avatarUri || loading"
        class="t-avatar-image"
      >
        <img
          v-if="loading"
          alt="loading"
          src="@shared/assets/img/general/loading-white.svg"
        >
        <img
          v-else
          :src="avatarUri"
          alt="Avatar"
          :class="['t-avatar', technician.pendingProfileChanges && technician.pendingProfileChanges.approvalPending ? 'pending' : '']"
        >
        <div
          v-if="!loading && technician.pendingProfileChanges && technician.pendingProfileChanges.approvalPending"
          class="ac-image-edit-container"
        >
          <img
            src="@shared/assets/img/technician/pending.svg"
            alt="Edit"
            class="t-pending-icon"
          />
        </div>
      </div>
      <div
        v-else
        class="t-avatar-circle"
      >
        {{ avatarName }}
      </div>
    </button>
    <div
      class="t-info-container"
      @click="goToDetail(technician)"
      @keypress="goToDetail(technician)"
    >
      <div class="t-header">
        {{ technician.firstName }}
        {{ technician.lastName }}
      </div>
      <a
        class="t-link"
        :href="`mailto:${technician.email}`"
        @click.stop
      >
        {{ technician.email }}
      </a>
      <a
        v-if="technician.phone"
        class="t-link"
        :href="`tel:${technician.phone}`"
        @click.stop
      >
        {{ technician.phone }}
      </a>
    </div>
    <div
      class="t-info-container"
      @click="goToDetail(technician)"
      @keypress="goToDetail(technician)"
    >
      <div class="t-body">
        Homeowners Served:
        {{ technician.unitCount }}
      </div>
      <div class="t-body">
        {{ technician.companyName }}
      </div>
    </div>
    <div
      v-if="myTechEnabled"
      class="t-info-container"
    >
      <div class="t-body">
        Video Chat On Call
      </div>
      <div class="t-body">
        <SACToggleSwitch
          :checked="isMyTech"
          :change="handleToggle"
        />
      </div>
    </div>
    <div class="t-info-container">
      <div
        v-if="technician.lastInvite && technician.createPassword"
        class="pending-container"
      >
        <div class="t-status-circle">
          <img
            src="@shared/assets/img/general/clock-navy-white.svg"
            alt="Clock"
            class="t-status-clock-icon"
          >
        </div>
        <div class="flex-column">
          <div class="t-header-pending">
            Pending
          </div>
          <div class="t-date-pending">
            <span v-if="technician.lastInvite">
              since {{ fullDateFormat(technician.lastInvite, dateFormat) }}
            </span>
            <span v-else>no date</span>
          </div>
        </div>
      </div>
      <div
        v-else-if="technician.accountStatus === 'Deactivated'"
        class="t-status-container"
      >
        <div class="flex-column">
          <div class="t-header">
            Deactivated
          </div>
          <div class="t-date">
            On
            {{ fullDateFormat(technician.updateDate, dateFormat) }}
          </div>
        </div>
      </div>
      <div
        v-else
        class="t-status-container"
      >
        <div class="t-status-circle">
          <img
            src="@shared/assets/img/general/check-white.png"
            alt="Check"
            class="t-status-icon"
          >
        </div>
        <div class="flex-column">
          <div class="t-header">
            Active
          </div>
          <div class="t-date">
            Joined
            {{ fullDateFormat(technician.creationDate, dateFormat) }}
          </div>
        </div>
      </div>
      <div
        v-if="adminRole === 'admin'"
        class="t-button-container"
      >
        <button
          type="button"
          :class="[
            technician.lastInvite && technician.createPassword ? 'yellow-btn' : '',
            't-button',
          ]"
          @click.stop="toggleActionModal(true, 'edit-tech', technician)"
        >
          <img
            src="@shared/assets/img/general/pen-black.png"
            alt="Edit"
            class="edit-icon"
          >
          Edit
        </button>
        <button
          type="button"
          :class="[
            technician.lastInvite && technician.createPassword ? 'yellow-btn' : '',
            't-button',
          ]"
          @click.stop="toggleActionModal(true, 'reset-tech', technician)"
        >
          <img
            src="@shared/assets/img/general/lock-black.png"
            alt="Reset Password"
            class="reset-icon"
          >
          Reset Password
        </button>
        <button
          v-if="technician.accountStatus === 'Active'
            && (!technician.lastInvite || !technician.createPassword)"
          type="button"
          class="t-button"
          @click.stop="toggleActionModal(true, 'deactivate-tech', technician)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="Deactivate"
            class="deactivate-icon"
          >
          Deactivate
        </button>
        <button
          v-if="technician.accountStatus === 'Deactivated'"
          type="button"
          :class="[
            !technician.lastInvite && technician.createPassword ? 'yellow-btn' : '',
            't-button',
          ]"
          @click.stop="toggleActionModal(true, 'reactivate-tech', technician)"
        >
          <img
            src="@shared/assets/img/general/check-black.png"
            alt="Active"
            class="active-icon"
          >
          Active
        </button>
        <button
          v-if="technician.lastInvite && technician.createPassword"
          type="button"
          class="t-button yellow-btn"
          @click.stop="resendInvite(technician)"
        >
          <img
            src="@shared/assets/img/general/check-black.png"
            alt="Re-invite"
            class="reinvite-icon"
          >
          Re-invite
        </button>
        <button
          v-if="technician.lastInvite && technician.createPassword"
          type="button"
          class="t-button yellow-btn"
          @click.stop="toggleActionModal(true, 'cancel-invite', technician)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="Cancel"
            class="deactivate-icon"
          >
          Cancel Invite
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import formatterMixin from '@shared/mixins/formatterMixin';
import technicianMixin from '@shared/mixins/technicianMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';
import apiClient from '@shared/lib/general/apiClient';
import SACToggleSwitch from '@shared/components/sac/SACToggleSwitch.vue';

export default {
  name: 'TechnicianItem',
  components: {
    SACToggleSwitch,
  },
  mixins: [formatterMixin, technicianMixin, unitPreferencesMixin],
  props: {
    technician: Object,
    resendInvite: Function,
  },
  data() {
    return {
      avatarUri: '',
      loading: false,
      isMyTech: false,
    };
  },
  computed: {
    ...mapState({
      partnerSettings: (state) => state.technician.partnerSettings,
    }),
    avatarName() {
      const {
        firstName,
        lastName,
      } = this.technician;
      if (firstName && lastName) {
        return `${firstName[0]}${lastName[0]}`;
      }
      return '--';
    },
    avatarUrl() {
      if (this.technician.profileUrl) {
        return this.technician.profileUrl;
      }
      if (this.technician.pendingProfileChanges?.profileUrl) {
        return this.technician.pendingProfileChanges.profileUrl;
      }
      return '';
    },
    myTechEnabled() {
      return this.partnerSettings?.TECH_MYTECH_SETTINGS?.toLowerCase() === 'yes';
    },
  },
  watch: {
    avatarUrl() {
      this.getAvatarImg();
    },
  },
  mounted() {
    if (this.technician.profileUrl || this.technician.pendingProfileChanges?.profileUrl) {
      this.getAvatarImg();
    }
    this.isMyTech = this.technician?.isMyTech;
  },
  methods: {
    async handleToggle() {
      const isMyTech = !this.isMyTech;
      this.isMyTech = isMyTech;
      const updateTech = {
        ...this.technician,
        isMyTech,
      };
      await this.$store.dispatch('updateTechnician', { updateTech });
    },
    goToDetail(technician) {
      const {
        id,
      } = technician;
      this.$store.dispatch('changeTechnicianValue', {
        field: 'selectedTech',
        value: technician,
      });
      this.$router.push(`/technician/${id}`);
    },
    async getAvatarImg() {
      this.loading = true;
      try {
        const { data } = await apiClient({
          method: 'PUT',
          url: '/devices/ac/image/response',
          data: {
            url: this.technician.pendingProfileChanges?.profileUrl ? this.technician.pendingProfileChanges?.profileUrl : this.technician.profileUrl,
          },
        });
        this.avatarUri = data;
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">

.t-item-container {
  background-color: $N95;
  margin-bottom: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: $N90;

    .t-button-container {
      display: flex;
    }

    .pending-container {
      background-color: transparent;
    }

    .t-status-container {
      opacity: 0;
    }
  }

  .t-info-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;

    &:first-child {
      flex: 0;
      margin-right: 30px;
      cursor: pointer;
    }

    &:nth-child(2) {
      align-items: flex-start;
    }

    &:nth-child(4) {
      flex: 0.5;
    }
    &:last-child {
      flex: 0.5;
    }

    .t-avatar-image {
      width: 40px;
      height: 40px;

      .t-avatar {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
        &.pending {
          filter: brightness(50%);
        }
      }
    }

    .t-avatar-circle {
      width: 40px;
      height: 40px;
      color: $NBLUE110;
      background-color: $WHITE;
      border-radius: 50%;
      font-size: 1.25rem;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .t-pending-icon {
      position: absolute;
      width: 15px;
      height: 15px;
      top: 25px;
      right: 0px;
    }

    .t-header {
      font-size: 1.125rem;
      color: $WHITE;
      font-weight: 600;
      margin-bottom: 4px;
      line-height: 1;
    }

    .t-header-pending {
      font-size: 1.125rem;
      color: $BLACK;
      font-weight: 600;
      margin-bottom: 2px;
      line-height: 1;
    }

    .t-link {
      font-size: 0.75rem;
      color: $N30;
      text-decoration: underline;
      font-weight: 500;

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }

    .t-body {
      color: $WHITE;
      font-weight: 500;
    }

    .t-date {
      color: $WHITE;
      font-size: 0.875rem;
    }

    .t-date-pending {
      color: $BLACK;
      font-size: 0.875rem;
      white-space: nowrap;
    }

    .t-status-circle {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: $N90;
      margin-right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      .t-status-icon {
        width: 60%;
      }

      .t-status-clock-icon {
        width: 42px;
        height: 42px;
      }
    }
  }

  .t-button-container {
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 16px;

    .t-button {
      height: 100%;
      background-color: $FRESH;
      padding: 10px 12px;
      height: 42px;
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 0.5rem;

      &:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      img {
        height: 80%;
      }

      &:hover {
        opacity: 1;
        background-color: #418E56;
      }

      &.yellow-btn {
        background-color: $SUNSET100;

        &:hover {
          opacity: 1;
          background-color: $SUNSET70;
        }
      }
    }
  }

  .pending-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: $SUNSET100;
    border-radius: 40px;
    padding: 5px 12px 5px 5px;
    &:hover {
      opacity: 1;
    }
  }

  .t-status-container {
    align-items: center;
    display: flex;
  }
}
</style>
